import React, { HTMLAttributes } from "react";
import Hidden from "@material-ui/core/Hidden";
// import { useSelector } from "react-redux";
import MobileMenu from "../../molecules/MobileMenu";
import DesktopMenu from "../../molecules/DesktopMenu";
import { SUserData } from "../../../store/selectors";
import { ReactComponent as SetupIcon } from "../../../assets/icons/setup.svg";

export interface IMenu extends HTMLAttributes<HTMLTableElement> {
  /** Full width menu */
  fullWidth?: boolean;
  /** Set Menu width config */
  width?: number;
  /** Menu items list */
  list: Array<any>;
  /** Menu items list */
  adminList?: Array<any>;
  /**
   * logoClickHandler
   */
  logoClickHandler?: () => void;
  subtitle?: string;
  profileElement?: JSX.Element;
}

const Menu = (props: IMenu) => {
  const { list, adminList } = props;

  return (
    <>
      <Hidden smDown>
        <DesktopMenu {...props} list={list} adminList={adminList} />
      </Hidden>
      <Hidden mdUp>
        <MobileMenu {...props} />
      </Hidden>
    </>
  );
};

export default Menu;
